const showBillingAddressDropReducer = (state = false, action) => {
	switch(action.type){
	case 'SHOWDROPTRUE':	
		return true;
	case 'SHOWDROPFALSE':
		return false;
	default:
		return state;
	}
}

export default showBillingAddressDropReducer;